let ol = require('openlayers');

let baseMapDictionary = [
  {
    id: "osm",
    title: "OpenStreetMap",
    layers: [
      new ol.layer.Tile({
        source: new ol.source.OSM()
      })
    ]
  },
  {
    id: "watercolor",
    title: "WaterColor by Stamen",
    layers: [new ol.layer.Tile({
      source: new ol.source.Stamen({
        layer: 'terrain-labels'
      })
    }),
      new ol.layer.Tile({
        source: new ol.source.Stamen({
          layer: 'watercolor'
        })
      })]
  },
  {
    id: "toner",
    title: "Toner by Stamen",
    layers: [
      new ol.layer.Tile({
        source: new ol.source.Stamen({
          layer: 'toner'
        })
      })]
  },
  {
    id: "terrain",
    title: "Terrain by Stamen",
    layers: [
      new ol.layer.Tile({
        source: new ol.source.Stamen({
          layer: 'terrain-labels'
        })
      }),
      new ol.layer.Tile({
        source: new ol.source.Stamen({
          layer: 'terrain'
        })
      })]
  },
  {
    id: "none",
    title: "Blank BaseMap",
    layers: []
  },
  {
    id: "undefined",
    title: "Default (OSM)",
    layers: [new ol.layer.Tile({
      source: new ol.source.OSM()
    })]
  }
];

function getBaseMaps() {
  return baseMapDictionary;
}

function addBaseMap(item) {
  baseMapDictionary.push(item);
}

module.exports = {
  add: addBaseMap,
  items: getBaseMaps,
};